export default
{
    emits:
    [
        'update:modelValue',
        'toggle',
        'hoverDate',
        'startSelection',
        'select',
        'change-month',
        'finishSelection'
    ]
}